var geoCoordMap = {};
export function initCharts(mychart, worlddata, geoCoordMapdata) {
  geoCoordMap = geoCoordMapdata;

  mychart.clear();

  //初始化数据
  var json = worlddata;

  var seriesJson = [];
  var tCityJsonData = [];
  var worldPieces =  []
  // console.log(json)
  // if(json.length !== 0){
  //   worldPieces = json[0].pieces 
  //   var colorTrade = ['#763c9c', '#f89623', '#0f58d1', '#f15847'];
  //   worldPieces.forEach((item,index) => {
  //     item.color = colorTrade[index]
  //   })
  // }
  
  //将json转成数组
  if (json != null && json.length > 0) {
    // console.log(json,'json')
    for (var i = 0; i < json.length; i++) { //年度
      var year = json[i].year;
      var arrname = "ChinaData" + year;
      var content = "";
      var arrContent = [];
      
      if (json != null && json.length > 0) { //每年数量
        for (var j = 0; j < json[0].data.length; j++) {
          var fcity = json[i].data[j][0].name;
          // var fcity="中国";
          var tcity = json[i].data[j][1].name;
          var value = json[i].data[j][1].value;
           worldPieces = json[i].pieces;
          // console.log(json[i].pieces,'json[i].pieces;')
          content = [{
            name: fcity
          }, {
            name: tcity,
            value: value,
            year: year,
            // worldPieces: worldPieces
          }];
          arrContent.push(content);
          let fromCoord = geoCoordMap[fcity];
          let toCoord = geoCoordMap[tcity];
          if (toCoord != undefined)
            tCityJsonData.push({
              name: tcity,
              value: [toCoord[0], toCoord[1], 30, value],
            }, {
              name: fcity,
              value: [fromCoord[0], fromCoord[1], 30, value],
            })
        }
      }
      seriesJson.push(arrContent);
    }
  }

  var planePath = 'arrow'; //箭头的svg

  //获取地图中起点和终点的坐标，以数组形式保存下来
  var convertData = function (data) {
    var res = [];
    var fromCoord = geoCoordMap[data[0].name];
    var toCoord = geoCoordMap[data[1].name];
    if (fromCoord && toCoord) {
      res.push({
        fromName: data[0].name,
        toName: data[1].name,
        value: data[1].value,
        year: data[1].year,
        coords: [fromCoord, toCoord]
      })
    }
    return res;
  }


  var series = []; // 用来存储地图数据
  var color = ['#763c9c', '#f89623', '#0f58d1', '#f15847'];

  seriesJson.forEach(function (item, i) { 
    item.forEach(function (itemSon, j) {
      series.push({
        type: 'lines',
        zlevel: 2,
        // effect: {
        //   show: true,
        //   period: 6,
        //   trailLength: 0,
        //   symbol: planePath,
        //   symbolSize: 7
        // },
        effect: {
          // 括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
          show: true,
          period: 4, //箭头指向速度，值越小速度越快
          trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
          // symbol: 'circle', //箭头图标
          symbol: 'arrow', //箭头图标
          symbolSize: 5, //图标大小
          color: "#fff",
        },
        lineStyle: {
          normal: {
            color: [],
            width: 1,
            opacity: 0.3,
            curveness: (i - 0.3) * 0.2 //幅度
          }
        },
        data: convertData(itemSon)
      });
    });
  });

  //显示终点位置,类似于上面最后一个效果，放在外面写，是为了防止被循环执行多次
  series.push({
    type: 'effectScatter',
    coordinateSystem: 'geo',
    zlevel: 3,
    rippleEffect: {
      brushType: 'stroke'
    },
    label: {
      normal: {
        show: true,
        position: 'left',
        formatter: '{b}'
      }
    },
    symbolSize: function (val) {
      return val[2] / 8;
    },
    data: tCityJsonData
  });

   //返回数据中无数据时，给个无数据图例
   if (worldPieces == "") {
    worldPieces.push({
      min: 0,
      label: '无数据'
    });
  }

  //最后初始化世界地图中的相关数据
  var option = {
    backgroundColor: '#f8f8f8',
    title: {
      text: '单位：百万美元',
      left: 'right',
      padding: [25, 100, 0, 0],
      textStyle: {
        color: '#5b9bd5',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        fontSize: 15
      },
      top: '0%',
      right: 20,
    },
    toolbox: {
      top: "10px",
      right: "20px",
      itemSize: 20,
      feature: {
        saveAsImage: {
          pixelRatio: 2
        }
      }
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: '#999',
      'confine': true,
      'formatter': function (p) {
        var dataCon = p.data;
        // MousehoverStyle(dataCon);
        // mychart.setOption({
        //   series: series
        // });
        return "年份：" + dataCon.year + "<br/>" + dataCon.fromName + ' -> ' + dataCon.toName + '<br/>金额：' + dataCon.value;
      },
    },
    visualMap: {
      type: 'piecewise',
      pieces: worldPieces, //每次改变visualmap
      hoverLink: true, //鼠标悬浮到 visualMap 组件上时，鼠标位置对应的数值 在 图表中对应的图形元素，会高亮
      left: "left", //组件离容器左侧的距离,'left', 'center', 'right','20%'
      top: "bottom", //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
      right: "20%", //组件离容器右侧的距离,'20%'
      bottom: "20%", //组件离容器下侧的距离,'20%'
      orient: "vertical", //图例排列方向
      padding: [50, 10, 100, 300], //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
      realtime: false,
      calculable: false,
      inRange: { //定义 在选中范围中 的视觉元素
        color: color
      },
      show: true
    },
    geo: {
      map: 'world',
      label: { // 鼠标移到各个地区显示地区名称
        emphasis: {
          show: true
        }
      },
      roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
      scaleLimit: { //滚轮缩放的极限控制
        min: 1,
        max: 2
      },
      itemStyle: {
        normal: {
          areaColor: '#8dd1fc',
          borderColor: '#6c8593'
        },
        emphasis: {
          areaColor: '#ffcc5f'
        }
      },
      regions: [{}]
    },
    series: series, // 将之前处理的数据放到这里
    textStyle: {
      fontSize: 12
    }
  };
// console.log(option,'worldPiecestrade')
  mychart.setOption(option);

  // mychart.on('mouseout', function () {
  //   MouseoutStyle(series);
  //   mychart.setOption({
  //     series: series
  //   });
  // });


  //鼠标移上样式
  var MousehoverStyle = function (p) {
    for (var i = 0; i < series.length; i++) {
      if (series[i].data.length == 1) {
        if (series[i].data[0].fromName == p.fromName && series[i].data[0].toName == p.toName && series[i].data[0].value == p.value && series[i].data[0].year == p.year) {
          series[i].lineStyle.normal.width = 3;
          series[i].lineStyle.normal.opacity = 1;
        } else {
          series[i].lineStyle.normal.opacity = 0.1;
          series[i].lineStyle.normal.width = 2;
        }
      }
    }
  }

  //鼠标移开样式
  var MouseoutStyle = function (p) {
    for (var i = 0; i < series.length; i++) {
      if (series[i].type == 'lines') {
        if (series[i].lineStyle.normal.width == 3) {
          series[i].lineStyle.normal.width = 2;
          series[i].lineStyle.normal.opacity = 0.3;
        } else {
          series[i].lineStyle.normal.width = 2;
          series[i].lineStyle.normal.opacity = 0.3;
        }
      }
    }
  }

}
